/** The agent screen and its cards, translation on the phone, and the rate card's source line. */
export const agent = {
    "agent.headline": "Talk to your agent.",
    "agent.soft": "Your notes stay here.",
    "agent.placeholder": "Speak or type…",
    "agent.empty": "Ask me something, or tap one of these.",
    "agent.suggest_rate": "Change my rate",
    "agent.suggest_earned": "What did I earn this week?",
    "agent.earnings": "This week you received {week}, and {month} this month. Still to come: {waiting}.",
    "agent.sources.one": "from {count} note",
    "agent.sources.other": "from {count} notes",
    "card.text": "Agent",
    "card.saved": "Saved",
    "card.answer": "Answer",
    "card.draft": "Draft",
    "card.needs_model": "Needs a model",
    "card.clarify": "Question",
    "agent.clarify": "I'm not sure what you'd like me to do. Did you mean:",
    "agent.thinking": "Thinking…",
    "choose.editCard": "Change my card",
    "choose.helpOffer": "Help people new to the city",
    "choose.helpStop": "Stop helping newcomers",
    "choose.moving": "I'm moving to another city",
    "choose.earnings": "What I earned",
    "choose.market": "What this work pays",
    "choose.guide": "Settling in the new city",
    "choose.find": "Find someone for a job",
    "choose.remember": "Save this as a note",
    "choose.askSelf": "Look in my notes",
    "choose.askContact": "Ask my contact",
    "choose.setRule": "What my contact may see",
    "choose.schedule": "My schedule",
    "choose.chat": "Something else",
    "agent.saved": 'Saved: "{text}"',
    "agent.nothing": "I have nothing saved about that.",
    "agent.no_contact": "I don't have {name} in your contacts yet.",
    "agent.ask_contact": 'Ask {name}: "{text}"?',
    "agent.rules_later": 'I can change your card. Say what to change, like "change my rate".',
    "agent.market_later": "Customers near you find your card on the board. New requests show on Today.",
    "agent.needs_model": "I can't do that on this phone yet. I can make your card and remember things for you.",
    "said.translating": "Translating on this phone…",
    "said.cannot": "In {lang}. This phone can't translate it yet.",
    "said.unsafe": "In {lang}. The translation changed a number, so it is not shown.",
};
//# sourceMappingURL=agent.js.map